<div class="custom-multi-select-data-fetch">
  <!-- Dynamic Input Section -->
  <div class="input-section">
    <ng-container *ngFor="let fieldConfig of inputFields">
      <div class="mb-3">
        <label [for]="fieldConfig.key" class="form-label">
          {{ fieldConfig.label | translate }}
          <span *ngIf="fieldConfig.required" class="text-danger">*</span>
        </label>
        <input
          [id]="fieldConfig.key"
          [type]="fieldConfig.type || 'text'"
          class="form-control"
          [formControl]="inputControls.get(fieldConfig.key)!"
          [disabled]="isDisabled"
          [placeholder]="
            fieldConfig.placeholder ? (fieldConfig.placeholder | translate) : ''
          " />
        <small *ngIf="fieldConfig.hint" class="form-text text-muted">
          {{ fieldConfig.hint | translate }}
        </small>
      </div>
    </ng-container>

    <!-- Validate Button -->
    <div class="mb-4 d-flex justify-content-end">
      <button
        type="button"
        class="btn btn-primary validate-btn"
        [disabled]="isDisabled || !isFormValid || isLoading"
        (click)="searchData()">
        <span *ngIf="!isLoading">{{
          config.validateButtonLabel
            ? (config.validateButtonLabel | translate)
            : ('CUSTOM_MULTI_SELECT.VALIDATE' | translate)
        }}</span>
        <span *ngIf="isLoading">
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"></span>
          {{ 'CUSTOM_MULTI_SELECT.LOADING' | translate }}
        </span>
      </button>
    </div>
  </div>

  <!-- Error Message -->
  <div
    *ngIf="errorMessage && !isLoading"
    class="alert alert-danger"
    role="alert">
    <i class="fa fa-exclamation-circle me-2"></i>
    {{ errorMessage }}
  </div>

  <!-- Results Table -->
  <div
    *ngIf="!isLoading && hasSearched && tableData.length > 0"
    class="results-section mt-4">
    <!-- Header with count badge -->
    <div class="results-header mb-3">
      <h5 class="results-title">
        {{
          config.tableTitle
            ? (config.tableTitle | translate)
            : ('CUSTOM_MULTI_SELECT.RESULTS' | translate)
        }}
        <span
          style="background-color: #eaf4ff; color: #0099ef"
          class="badge ms-2"
          *ngIf="selectedCount > 0">
          {{ selectedCount }}
        </span>
      </h5>
      <p class="text-muted">
        {{
          config.tableDescription ? (config.tableDescription | translate) : ''
        }}
      </p>
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 40px">
              <input
                type="checkbox"
                [checked]="allSelected"
                [indeterminate]="
                  selectedCount > 0 && selectedCount < tableData.length
                "
                (change)="toggleAllSelection()"
                [disabled]="isDisabled" />
            </th>
            <th *ngFor="let column of getColumnConfiguration()">
              {{ column.title | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Data rows -->
          <tr
            *ngFor="let item of tableData"
            [class.selected-row]="item['selected']"
            (click)="toggleItemSelection(item)"
            (keydown.enter)="toggleItemSelection(item)"
            (keydown.space)="$event.preventDefault(); toggleItemSelection(item)"
            tabindex="0"
            role="row">
            <td>
              <input
                type="checkbox"
                [checked]="item['selected']"
                (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()"
                (keydown.space)="$event.stopPropagation()"
                (change)="toggleItemSelection(item)"
                [disabled]="isDisabled" />
            </td>
            <td *ngFor="let column of getColumnConfiguration()">
              {{ getFormattedValue(item, column) }}
            </td>
          </tr>

          <!-- Loading shimmer rows -->
          <ng-container *ngIf="isLoading">
            <tr *ngFor="let item of [1, 2, 3, 4, 5]">
              <td><div class="line loading-shimmer"></div></td>
              <td *ngFor="let column of getColumnConfiguration()">
                <div class="line loading-shimmer"></div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="w-100 mt-3 px-4" *ngIf="totalElements > pageSize">
      <irembogov-data-table-pagination
        [collectionSize]="totalElements"
        [page]="currentPage + 1"
        [disabled]="isDisabled"
        [pageSize]="pageSize"
        [showDropdown]="true"
        (paginatedValues)="onPageChange($event)">
      </irembogov-data-table-pagination>
    </div>
  </div>

  <!-- No Results Message -->
  <div
    *ngIf="!isLoading && hasSearched && tableData.length === 0 && !errorMessage"
    class="text-center py-4">
    <i class="fa fa-search text-muted" style="font-size: 3rem"></i>
    <p class="text-muted mt-3">
      {{
        config.emptyMessage
          ? (config.emptyMessage | translate)
          : ('CUSTOM_MULTI_SELECT.NO_RESULTS' | translate)
      }}
    </p>
  </div>
</div>
